import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { ProductAttributeDeleteCard } from './components/AttributeDeleteCard';
import { AttributeDetailsCard } from './components/AttributeDetailsCard';
import { AttributeValuesCard } from './components/AttributeValuesCard';

export function ProductAttributeDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const productAttributeQueryResults = useQuery({
        queryKey: ['productAttribute', id],
        queryFn: () =>
            Api.Products.ProductAttributes.getProductAttribute(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={productAttributeQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <AttributeDetailsCard productAttribute={data} />
                            <AttributeValuesCard
                                productAttribute={data}
                                refetch={productAttributeQueryResults.refetch}
                            />

                            {!data.attributeValues.length && (
                                <Can I="delete" a="Product">
                                    <ProductAttributeDeleteCard
                                        productAttribute={data}
                                    />
                                </Can>
                            )}
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
